module.exports = __webpack_public_path__ + "img/tbt894-1999.prt.4f391aca.jpg";